import React, { useRef } from 'react';
import userPlaceholder from '../../../../assets/profile/placeholder.png';

const ProfileView = ({ data, onEdit, onImageUpdate }) => {
    const fileInputRef = useRef(null);

    const renderValue = (val, label) => {
        if (!val || val === "") {
            return (
                <span className="text-[#4096F6] cursor-pointer hover:underline font-medium text-[14px] md:text-[16px]">
                    Add {label}
                </span>
            );
        }
        return <span className="text-[#4096F6] font-[500] text-[14px] md:text-[16px]">{val}</span>;
    };

    return (
        <div className="bg-white rounded-[10px] border border-[#E0E0E0] p-6 md:p-12 min-h-[auto] md:min-h-[550px] shadow-sm animate-in fade-in duration-500">
            <div className="max-w-[750px] mx-auto relative text-left">

                <button
                    onClick={onEdit}
                    className="absolute right-0 md:-right-10 -top-2 md:top-0 text-[#4096F6] font-[500] text-[14px] md:text-[18px] hover:underline"
                >
                    Edit
                </button>

                {/* <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    className="hidden"
                    accept="image/*"
                /> */}

                <div className="flex flex-col gap-6 md:gap-8 pt-4 md:pt-6">
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-10 md:ml-14">
                        <span className="w-full sm:w-[180px] sm:text-right text-[15px] md:text-[18px] tracking-tight font-[500] text-[#000000]">
                            Profile Picture :
                        </span>
                        <div className="flex items-center gap-4">
                            <img
                                src={data.image || userPlaceholder}
                                alt="User"
                                className="w-[55px] h-[55px] md:w-[68px] md:h-[68px] rounded-full object-cover border border-gray-100 shadow-sm"
                            />

                            {/* <button
                                type="button"
                                onClick={() => fileInputRef.current.click()}
                                className="text-[#4096F6] font-[500] text-[13px] md:text-[18px] hover:underline"
                            >
                                Change
                            </button> */}

                            {/* Hidden File Input (IMPORTANT) */}
                            <input type="file" ref={fileInputRef}
                                onChange={''}
                                accept="image/*"
                                className="hidden"
                            />
                        </div>
                    </div>
                    {[
                        { label: "Full Name", key: "name" },
                        { label: "Date of Birth", key: "dob" },
                        { label: "Education", key: "education" },
                        { label: "Category", key: "category" },
                        { label: "Location", key: "location" },
                        { label: "Default Language", key: "language" },
                    ].map((item) => (
                        <div key={item.key} className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10 md:ml-14">
                            <span className="w-full sm:w-[180px] sm:text-right text-[15px] md:text-[18px] tracking-tight font-[500] text-[#000000]">
                                {item.label} :
                            </span>
                            <div className="sm:text-[16px] ">
                                {renderValue(data[item.key], item.label)}
                            </div>
                        </div>
                    ))}

                    {/* Mobile Number Section */}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-10 md:ml-14">
                        <span className="w-full sm:w-[180px] sm:text-right text-[15px] md:text-[18px] font-[500] text-[#000000]">
                            Mobile Number :
                        </span>
                        <span className="text-[14px] md:text-[16px] font-medium text-[#4096F6]">
                            {"+91 " + data.phone || "+91"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileView;